import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './autocomplete_entity_item.module.scss';

export const AutocompleteEntityItem: FC<{
  selected: boolean;
  [s: string]: any;
}> = ({ selected, ...props }) => (
  <span
    {...props}
    className={classNames(
      'search-bar-dropdown__cell',
      styles.item,
      props.className,
      {
        [styles.selected]: selected,
      },
    )}
  />
);

export const AutocompleteEntityItemLabel: FC = (props) => (
  <span {...props} className={styles.label} />
);
